export default 'https://tme.understood.org/assets/television.ec80c7fd.lottie'